import 'css-chunksrc/client/scenes/calendar/loader/styles.scss';export default {
  "loader": "_loader_p94lu_1",
  "row": "_row_p94lu_11",
  "event": "_event_p94lu_19",
  "halved": "_halved_p94lu_26",
  "quarter": "_quarter_p94lu_30",
  "right": "_right_p94lu_34",
  "left": "_left_p94lu_38"
};